var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unlock-layout layers"},[_c('div',{ref:"scroller",staticClass:"scroller"},[_c('div',{ref:"content",staticClass:"long-content"},[_c('div',{staticClass:"top-taller"}),_vm._v(" "),_c('div',{staticClass:"unlocking-title"},[_vm._v("\n        "+_vm._s(_vm.T('/unlock@unlocking-title'))+"\n      ")]),_vm._v(" "),_c('EffectFilter',{staticClass:"share-image-target",on:{"upload":function (ref) {
var avatar = ref.avatar;
var social = ref.social;
var small = ref.small;
 _vm.prepShare({ avatar: avatar, social: social, small: small }) },"home":function($event){_vm.$router.push('/')}}}),_vm._v(" "),_c('div',{staticClass:"bottom-taller"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2641641c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Unlock/Unlock.vue
// module id = 475
// module chunks = 0